/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDatabaseExport = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4.292 5.58c.28-.248.744-.518 1.402-.765C7.004 4.325 8.88 4 11 4s3.997.324 5.306.815c.658.247 1.121.517 1.402.766.282.25.292.393.292.419s-.01.17-.292.42c-.28.248-.744.518-1.402.765C14.996 7.675 13.12 8 11 8s-3.997-.324-5.306-.815c-.658-.247-1.121-.517-1.402-.766C4.01 6.17 4 6.026 4 6s.01-.17.292-.42zM18 8.617V13h2V6c0-.803-.438-1.448-.965-1.916-.53-.469-1.238-.846-2.027-1.142C15.422 2.347 13.298 2 11 2c-2.297 0-4.422.347-6.008.942-.79.296-1.498.673-2.027 1.142C2.437 4.552 2 5.197 2 6v12c0 .803.437 1.448.965 1.916.53.469 1.238.846 2.027 1.142C6.578 21.653 8.702 22 11 22c1.521 0 2.96-.152 4.212-.424l-.424-1.955c-1.1.24-2.395.379-3.788.379-2.121 0-3.997-.324-5.306-.815-.658-.247-1.121-.517-1.402-.765C4.01 18.17 4 18.024 4 18v-3.384c.31.164.643.31.992.442C6.578 15.652 8.702 16 11 16c1.521 0 2.96-.152 4.212-.424l-.424-1.955c-1.1.24-2.395.379-3.788.379-2.121 0-3.997-.324-5.306-.815-.658-.247-1.121-.517-1.402-.765C4.01 12.17 4 12.026 4 12V8.616c.31.164.643.31.992.442C6.578 9.653 8.702 10 11 10c2.297 0 4.422-.347 6.008-.942A8.52 8.52 0 0 0 18 8.616zm1 5.97 3.707 3.707-1.414 1.414L20 18.414V22h-2v-3.586l-1.293 1.293-1.414-1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDatabaseExport as DatabaseExport };
